import { Box, Button, Typography } from "@mui/material";
import React from "react";

interface ItemFormHeaderProps {
  step: number;
  setStep: React.Dispatch<React.SetStateAction<number>>;
  setIsEditing: (bool: boolean) => void;
}

const ItemFormHeader = ({
  step,
  setStep,
  setIsEditing,
}: ItemFormHeaderProps) => {
  return (
    <Box>
      <Box
        sx={{
          padding: "1rem",
          marginRight: "auto",
          marginLeft: "auto",
          maxWidth: {
            xs: "100vw", // small
            sm: "70vw", // tab
            md: "50vw", // large
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {step > 1 && (
            <Button
              type="button"
              onClick={() => setStep((prevStep) => prevStep - 1)}
            >
              <Typography>Back</Typography>
            </Button>
          )}
          <Button
            type="button"
            sx={{
              display: "flex",
              justifyContent: "flex-end",
            }}
            onClick={() => {
              setIsEditing(false);
              setStep(1);
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          marginRight: "auto",
          marginLeft: "auto",
          maxWidth: {
            xs: "90vw", // small
            sm: "70vw", // tab
            md: "50vw", // large
          },
        }}
      >
        <Typography
          sx={{
            fontSize: "1rem",
          }}
        >
          Step
          <Typography
            component="span"
            sx={{
              fontWeight: "bold",
              fontSize: "1rem",
            }}
          >
            {" " + step + " "}
          </Typography>
          of 4
        </Typography>
        <Typography variant="h1" component="h1">
          {step === 1 && "Item Type"}
          {step === 2 && "Enter Details"}
          {step === 3 && "Pricing and Options"}
          {step === 4 && "Review and Save"}
        </Typography>
        <Typography
          sx={{
            color: "gray",
            fontSize: "0.8rem",
          }}
        >
          *Required fields
        </Typography>
      </Box>
    </Box>
  );
};

export default ItemFormHeader;
